import React from 'react';

// Play / pause shapes drawn with currentColor, so the button's `color`
// (a theme token) decides them. Rounded corners to match the line icons.
export function PlayGlyph({size = 28, className}) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <path d="M8 5.6v12.8a1.2 1.2 0 0 0 1.8 1l10-6.4a1.2 1.2 0 0 0 0-2L9.8 4.6A1.2 1.2 0 0 0 8 5.6z"
            fill="currentColor"/>
    </svg>
  );
}

export function PauseGlyph({size = 28, className}) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <rect x="6" y="5" width="4.2" height="14" rx="1.6" fill="currentColor"/>
      <rect x="13.8" y="5" width="4.2" height="14" rx="1.6" fill="currentColor"/>
    </svg>
  );
}

export function RecordGlyph({size = 28, className}) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <circle cx="12" cy="12" r="7" fill="currentColor"/>
    </svg>
  );
}

export function StopGlyph({size = 28, className}) {
  return (
    <svg className={className} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <rect x="6" y="6" width="12" height="12" rx="2.5" fill="currentColor"/>
    </svg>
  );
}
